import { addons } from '@storybook/manager-api'
import adverseComponentTheme from './adverse-components-theme'

addons.setConfig({
  theme: adverseComponentTheme
})
